import styled, { css } from 'styled-components';
import { useCompanyUsers } from 'src/components/domain/users/hooks/use-company-users';
import { LggUserAvatar } from 'src/components/general/display/user-avatar';
import { LoadingSpinner } from 'src/components/general/inputs/shared';
import { FlexRow } from 'src/components/layout/flex-row';

type StackedCompanyUserListProps = {
  selectedUsersIds: number[];
  maxItems?: number;
};

const baseItemStyles = css`
  height: 24px;
  width: 24px;

  &:not(:first-child) {
    margin-left: -12px;
  }
`;

const StyledLggUserAvatar = styled(LggUserAvatar)`
  ${baseItemStyles};
  border: 2px solid ${({ theme }) => theme.colors.white};
`;

const ListExtraItemsCount = styled(FlexRow)`
  ${baseItemStyles};
  align-items: center;
  background: ${({ theme }) => theme.colors.secondaryTopaz10};
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.casper};
  color: ${({ theme }) => theme.colors.gogo};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 12px;
  justify-content: center;
  letter-spacing: -0.8px;
  line-height: 13px;
  margin-top: 2px;
  text-align: center;
  z-index: 0;
`;

export const StackedCompanyUserList = (props: StackedCompanyUserListProps) => {
  const { selectedUsersIds, maxItems = 4, ...rest } = props;

  const { loading: loadingUserOptions, users } = useCompanyUsers({
    where: {
      isActive: {
        _eq: true,
      },
      id: {
        _in: selectedUsersIds,
      },
    },
    skip: selectedUsersIds.length === 0,
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
  });

  if (loadingUserOptions) {
    return <LoadingSpinner />;
  }

  const usersToDisplay = users.slice(0, maxItems);
  const extraItemsCount = users.length - usersToDisplay.length;

  return (
    <FlexRow {...rest}>
      {usersToDisplay.map((user) => {
        return (
          <StyledLggUserAvatar user={user} key={user.id} className="stacked-list-item" />
        );
      })}
      {extraItemsCount ? (
        <ListExtraItemsCount className="stacked-list-item list-extra-item-count">{`+${extraItemsCount.toLocaleString()}`}</ListExtraItemsCount>
      ) : null}
    </FlexRow>
  );
};
